import styled, { css } from 'styled-components';

export const StyledVehicleInfoCardContainer = styled.div``;

export const StyledVehicleInfoCard = styled.div<{ $isDealCentralMultiScenario?: boolean }>`
    display: flex;
    align-items: start;
    gap: ${({ theme }) => theme.tokens.BaseSpace40};

    ${({ $isDealCentralMultiScenario }) =>
        $isDealCentralMultiScenario &&
        css`
            border-bottom: 1px solid #b2b2b2;
            padding-bottom: 0.5rem;
        `}
`;

export const StyledVehicleInfoCardImage = styled.div`
    flex-shrink: 0;

    img {
        width: 9.5rem;
        max-height: 5.25rem;
        object-fit: cover;
        border-radius: 0.3rem;
        overflow-clip-margin: unset;
    }
`;

export const StyledVehicleInfoCardContent = styled.div`
    width: 100%;

    button {
        span {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            text-transform: capitalize;
        }
    }
`;

export const CompactStyledVehicleInfoCardStockVin = styled.div`
    margin-top: ${({ theme }) => theme.tokens.BaseSpace25};
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.375rem 1.143rem;

    > div:first-child {
        display: flex;
        gap: 0.375rem 1.143rem;
        flex-wrap: wrap;
        align-items: center;
    }
`;

export const StyledVehicleInfoCardBaseActionsCompact = styled.div<{ $shouldAlignFlexStart: boolean }>`
    display: flex;
    align-items: ${({ $shouldAlignFlexStart }) => ($shouldAlignFlexStart ? 'flex-start' : 'center')};
    padding: 0;
    gap: ${({ theme }) => theme.tokens.BaseSpace40};
    position: relative;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    justify-content: space-between;
    min-height: 36px;

    .ids-action {
        display: flex;
    }
    .ids-action svg {
        flex-shrink: 0;
    }

    > div:first-child {
        display: flex;
        align-items: flex-start;
        gap: ${({ theme }) => theme.tokens.BaseSpace40};

        .ids-action {
            display: flex;
        }
        .ids-action svg {
            flex-shrink: 0;
        }
    }
`;

/* Compact UI - container that takes full width */
export const CompactVehicleInfoWrapper = styled.div`
    width: 100%;
`;

/* Compact UI - left column with vehicle info */
export const CompactVehicleInfoLeft = styled.div`
    display: flex;
    flex-direction: column;
`;

/* Compact UI - smaller payment grid toggle to match action buttons */
export const CompactPaymentGridToggleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    transform: scale(0.85);
    transform-origin: center right;
    overflow: hidden;

    /* Remove bottom margin from Box wrapper */
    > div:last-child {
        margin-bottom: 0 !important;
    }

    .MuiInputLabel-root {
        display: none !important;
    }
`;

export const LabelWithIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    color: #6d6d6d;
    font-size: 12px;
    padding-right: 5px;
`;

export const StyledRepairOrderAlert = styled.span`
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    gap: ${({ theme }) => theme.tokens.BaseSpace10};
`;

export const StyledRepairOrderCount = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 18px;
    height: 18px;
    padding: 0 ${({ theme }) => theme.tokens.BaseSpace10};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.tokens.BaseColorRed500};
    color: ${({ theme }) => theme.tokens.BaseColorWhite};
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    cursor: pointer;
`;
